import { AttachIcon } from '@synergy/theme-next';
import { Box, IconButton, Stack } from '@mui/material';
import { Media } from '@synergy/models';
import { PaloNextThemeProvider } from '@synergy/theme-palo';
import { PoolFileList, PoolTooltip, PoolTypography } from '@synergy/components-next';

type FilesTooltipProps = {
    downloadBaseUrl?: string;
    files: Media[];
};

export const FilesTooltip = ({ files, downloadBaseUrl }: FilesTooltipProps) => {
    return (
        <PaloNextThemeProvider>
            <PoolTooltip
                title={
                    files.length > 0 && (
                        <Stack gap={2}>
                            <Box>
                                <PoolTypography
                                    sx={{ fontWeight: 600 }}
                                    variant="body1"
                                    translationId="app.toolTip.attachedSupplierFiles"
                                />
                            </Box>

                            <Box>
                                <PoolFileList
                                    acceptedFiles={files}
                                    hideTitle={true}
                                    readOnly={true}
                                    downloadBaseUrl={downloadBaseUrl}
                                />
                            </Box>
                        </Stack>
                    )
                }
                placement="top"
                variant="light"
            >
                <span>
                    <IconButton disabled={files.length === 0}>
                        <AttachIcon sx={{ color: theme => (files.length === 0 ? '' : theme.palette.common.black) }} />
                    </IconButton>
                </span>
            </PoolTooltip>
        </PaloNextThemeProvider>
    );
};
